import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTable = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6 10.3636V6.5C6 6.22386 6.22386 6 6.5 6H10.5M6 10.3636V17.5C6 17.7761 6.22386 18 6.5 18H10.5M6 10.3636H18M18 10.3636V17.5C18 17.7761 17.7761 18 17.5 18H10.5M18 10.3636V6.5C18 6.22386 17.7761 6 17.5 6H10.5M10.5 6V18",
		stroke: "black"
	})
});
export default SvgTable;
